import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-link-dear',
  templateUrl: './link-dear.component.html',
  styleUrls: ['./link-dear.component.scss']
})
export class LinkDearComponent implements OnInit  {

  @Input() partner;
  @Input() selectedPOS;
  @Input() modal;
  @Output() next = new EventEmitter();

  public accountID: string = '';
  public applicationID: string = '';
  public busy: boolean = false;
  public connected: boolean = false;
  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.busy = false;
  }

  SaveSettings() {
    this.posIntegrationService
      .savePOSConnection(this.partner.PartnerID, {
        PartnerID: this.partner.PartnerID,
        POSID: 10,
        AccountId: this.accountID,
        APIKey: this.applicationID,
      })
      .subscribe((x) => {
        if (this.modal !== undefined) this.modal.dismiss('Cross click');
        else this.next.emit();
      });
  }
}
